export enum CHAT_MESSAGE_TYPE {
  BAKERY = 'BAKERY',
  CUSTOMER = 'CUSTOMER'
}

/**
 * Discriminant value for error frames. Arrives verbatim: the socket deserializer
 * camelCases object keys only, never values.
 */
export const CHAT_MESSAGE_ERROR_FRAME_TYPE = 'message_error';

export enum CHAT_MESSAGE_ERROR_CODE {
  VALIDATION_ERROR = 'validation_error',
  MESSAGE_SEND_FAILED = 'message_send_failed'
}
